/* eslint-disable react/prop-types */
import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import { PageLoading } from "./LoadingState";
import { jwtDecode } from "jwt-decode";
import toast from "react-hot-toast";
import { pickUpSharedLogin } from "../Utils/SharedLogin";

export default function ProtectedRoute({ children }) {
  const navigate = useNavigate();

  // ✅ Read initial user once (no deps issues)
  const [user] = useState(() => {
    try {
      return JSON.parse(secureLocalStorage.getItem("profile"));
    } catch (e) {
      return null;
    }
  });


  // ✅ Decode token safely + memoized
  const decodedToken = useMemo(() => {
    if (!user?.token) return null;
    try {
      return jwtDecode(user.token);
    } catch (e) {
      return null;
    }
  }, [user?.token]);

  const exp = decodedToken?.exp;

  // ✅ Session expiry check
  useEffect(() => {
    if (!exp) return;

    const expirationDate = new Date(exp * 1000);
    const currentDate = new Date();

    if (currentDate > expirationDate) {
      toast.error("Your session has expired, please log in again");
      navigate("/stock/login");
    }
  }, [exp, navigate]);

  // ✅ No user → login
  useEffect(() => {
    if (!user) {
      // Signed in to another app already? Pick that login up instead.
      pickUpSharedLogin().then((picked) => {
        if (!picked) navigate("/stock/login");
      });
    }
  }, [user, navigate]);

  // ✅ Restricted user → login
  useEffect(() => {
    if (user?.results?.stock === "Restricted") {
      toast.error("You are restricted");
      navigate("/stock/login");
    }
  }, [user?.results?.stock, navigate]);

  // No login here yet: show a loader while checking for a shared login
  // (the effect above then reloads as that user, or goes to the login page)
  if (!user) return <PageLoading />;

  return children;
}
